var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 26,
    viewBox: "0 0 27 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.267578 0.339844H4.84472V4.98472H0.267578V0.339844ZM0.267578 7.59039H4.84472V26H0.267578V7.59039Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9997 25.9999H21.3667V15.8038C21.3667 14.3311 21.1435 13.3115 20.6411 12.6317C20.1387 11.952 19.4131 11.6121 18.52 11.6121C17.906 11.6121 17.292 11.7821 16.6221 12.0653C16.0081 12.4052 15.4499 12.8017 14.9476 13.3681C14.4452 13.9346 14.0545 14.5577 13.7754 15.294V25.9433H9.19824V7.76028H13.3847V11.159C13.8312 10.3659 14.4452 9.6862 15.1709 9.1764C15.8965 8.66659 16.678 8.21343 17.6269 7.93021C18.5758 7.64699 19.5247 7.47705 20.5853 7.47705C21.7017 7.47705 22.6506 7.70363 23.3762 8.10014C24.1019 8.49666 24.66 9.06311 25.0508 9.74285C25.4415 10.4226 25.7206 11.2156 25.8322 12.0653C25.9997 12.915 26.0555 13.7646 26.0555 14.6143V25.9999H25.9997Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.77f109037d45c771dad8a1149b9f3e23.svg";
export { ForwardRef as ReactComponent };